import React, { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from '../../../hooks/react-redux';
import { Group } from '../../shared/icons';
import { TypeDeleteConfirmationModal } from '../../shared/modal/TypeDeleteConfirmationModal';
import { deleteAccessGroupStarted, getCurrentAccessGroup, getDeletingAccessGroup } from './store';

interface DeleteConfirmationModalProps {
    isOpen: boolean;
    closeModal: () => void;
}

export const DeleteAccessGroupConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({ isOpen, closeModal }) => {
    const dispatch = useAppDispatch();
    const isDeleting = useAppSelector(getDeletingAccessGroup);
    const selectedAccessGroup = useAppSelector(getCurrentAccessGroup);
    const { accessGroupId, accessGroupName } = selectedAccessGroup;
    const deleteAccessGroup = useCallback(() => dispatch(deleteAccessGroupStarted(accessGroupId!)), [dispatch, accessGroupId]);

    const headerLabel = `Delete Access Group ${accessGroupName}?`;

    return (
        <TypeDeleteConfirmationModal
            isOpen={isOpen}
            closeModal={closeModal}
            deleteAction={deleteAccessGroup}
            isDeleting={isDeleting}
            headerLabel={headerLabel}
            name={accessGroupName}
            testId='access-group'
            icon={Group}
            warning='Once deleted, this access group will be permanently removed and cannot be recovered (but can be created again).'
        />
    );
};
